// extracted by mini-css-extract-plugin
export var billingAddress = "_r9-f";
export var contactInfo = "_r9-c";
export var customerInfoContainer = "_r9-b";
export var customerInfoRow = "_r9-9";
export var customerInfoSection = "_r9-a";
export var fullWidthDividerMobile = "_r9-g";
export var imageContainer = "_r9-1";
export var paymentMethod = "_r9-d";
export var priceText = "_r9-6";
export var priceTextMobile = "_r9-7";
export var product = "_r9-0";
export var productImage = "_r9-2";
export var productInfo = "_r9-4";
export var productTitle = "_r9-8";
export var quantityBadge = "_r9-3";
export var quantityText = "_r9-5";
export var shippingAddress = "_r9-e";